import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $screen from 'wee-screen';
import $events from 'wee-events';

class ExpandableList {

    constructor(el) {
        this.$list = $(el).find(':list');
        this.$hidden = $(el).find(':hiddenItem');
        this.$button = $(el).find(':expandButton');
        this.isExpanded = false;
    }

    expand() {
        this.$hidden.show();
        this.$list.aria('expanded', true)
            .addClass(this.expanded);
        this.$button.aria('label', this.$button.data('close'))
            .text(this.$button.data('close'));
        this.isExpanded = true;
    }

    close() {
        this.$hidden.hide();
        this.$list.aria('expanded', false)
            .addClass(this.expanded);
        this.$button.aria('label', this.$button.data('expand'))
            .text(this.$button.data('expand'));
        this.isExpanded = false;
    }

    full() {
        $screen.map([
            {
                max: 2,
                callback: () => {
                    this.close();
                    this.$button.show();
                    this.$hidden.hide();
                },
            },
            {
                min: 3,
                callback: () => {
                    this.expand();
                    this.$button.hide();
                    this.$hidden.show();
                },
            },
        ]);
    }
}

export default new RouteHandler({
    init() {
        $(':expandableList').each((el) => {
            const expand = new ExpandableList(el);

            if ($(el).data('full')) {
                expand.full();
            }

            $events.on(expand.$button, 'click', () => {
                if (expand.isExpanded) {
                    expand.close();
                } else {
                    expand.expand();
                }
            });
        });
    }
});
